import { defineComponent as me, useSlots as de, ref as n, useModel as xe, computed as u, useAttrs as be, watchEffect as he, watch as R, onMounted as pe, onBeforeUnmount as ye, openBlock as d, createElementBlock as M, mergeProps as ge, toHandlers as ke, createElementVNode as f, createVNode as x, createBlock as W, unref as r, createCommentVNode as b, createTextVNode as Ie, toDisplayString as Q, normalizeClass as z, mergeModels as Z } from "vue";
import { useResizeObserver as Ce } from "@vueuse/core";
import { RevButtonIcon as C } from "@ds/components/ButtonIcon";
import Te from "../../icons/generated/IconChevronLeft.vue2.js";
import we from "../../icons/generated/IconChevronRight.vue2.js";
import $ from "../../icons/generated/IconMediaPause.vue2.js";
import A from "../../icons/generated/IconMediaPlay.vue2.js";
import { useI18n as Ne } from "@ds/plugin";
import { track as Le } from "@ds/tracking/tracking";
import D from "../../translations/generic.translations.js";
import { isBrowser as Pe } from "../../utils/client.js";
import { isEmpty as Ee } from "../../utils/isEmpty.js";
import { tw as _ } from "../../utils/tailwind.js";
import { skipFragment as Se, isVNodeEmpty as Be } from "../../utils/vnode.js";
import Re from "../CardCarousel/components/CardCarouselController.vue2.js";
import { INTERVAL_IN_MILLISECOND as Me } from "./Carousel.constant.js";
import ee from "./components/CarouselController.vue2.js";
import We from "./components/CarouselItems.vue2.js";
const ze = { class: "relative flex w-full grow justify-center" }, $e = {
  class: "sr-only",
  role: "status"
}, Ae = ["aria-labelledby"], De = {
  key: 0,
  class: "mx-auto mt-16 flex w-full max-w-[1072px] items-center px-12"
}, Ve = { class: "ml-auto hidden items-center gap-12 md:flex" }, nt = /* @__PURE__ */ me({
  name: "RevCarousel",
  inheritAttrs: !1,
  __name: "Carousel",
  props: /* @__PURE__ */ Z({
    alternativeControllerButtonTranslation: {},
    alternativeNext: {},
    alternativePrevious: {},
    alternativePause: {},
    alternativePlay: {},
    tracking: { default: null },
    thumbnails: { default: () => {
    } },
    autoplay: { type: Boolean, default: !1 },
    interval: { default: () => Me },
    currentIndexId: {}
  }, {
    currentIndex: {
      default: 0
    },
    currentIndexModifiers: {}
  }),
  emits: /* @__PURE__ */ Z(["slide-impression", "next-button-click", "prev-button-click", "navigation-click", "swipe"], ["update:currentIndex"]),
  setup(t, { emit: te }) {
    const ae = de(), h = te, L = n(null), T = n(void 0), p = n(null), y = n(null), a = xe(t, "currentIndex"), w = n(0), N = n(0), g = n(!1), o = n(t.autoplay), k = n(!1), V = n(0), U = u(
      () => Se(ae?.default({})).filter(
        (e) => !Be(e)
      )
    ), i = u(() => U.value.length), H = Ne(), O = u(
      () => t.alternativeControllerButtonTranslation || D.carouselButtonLabel
    ), j = u(() => !Ee(t.thumbnails)), le = be(), ne = u(
      () => t.alternativePause || H(D.carouselPause)
    ), re = u(
      () => t.alternativePlay || H(D.carouselPlay)
    ), P = u(
      () => o.value ? ne.value : re.value
    );
    function X(e) {
      const l = e ?? a.value;
      h("slide-impression", { index: l }), Le({
        action: "carousel-impression",
        context: {
          ...le,
          ...t.tracking,
          currentSlide: l
        }
      });
    }
    const I = n(!1), E = n(0);
    function Y() {
      const e = p.value instanceof HTMLElement ? p.value.offsetWidth : 0, l = T.value instanceof HTMLElement ? T.value.offsetWidth : 48, s = n(0);
      E.value === 0 ? (s.value = L.value instanceof HTMLElement ? L.value.offsetWidth : 0, E.value = s.value) : s.value = E.value;
      const v = e - l * 2;
      return s.value > v;
    }
    function ie() {
      a.value >= i.value - 1 ? a.value = 0 : a.value += 1;
    }
    function oe() {
      a.value === 0 ? a.value = i.value - 1 : a.value -= 1;
    }
    function ue(e) {
      e !== a.value && (a.value = e);
    }
    function m(e) {
      g.value && (o.value = !1), typeof e == "number" && ue(e), e === "previous" && oe(), e === "next" && ie();
    }
    function F(e) {
      const l = e.touches[0];
      w.value = l.clientX, N.value = l.clientY;
    }
    function q(e) {
      if (!w.value || !N.value)
        return;
      const l = e.touches[0].clientX, s = e.touches[0].clientY, v = w.value - l, B = N.value - s;
      Math.abs(v) > Math.abs(B) && (h("swipe"), v > 0 ? m("next") : m("previous")), w.value = 0, N.value = 0;
    }
    const se = u(() => [
      I.value && _`absolute left-0 z-10 mt-4`
    ]), ce = u(() => [
      I.value && _`absolute right-0 z-10 mt-4`
    ]), ve = he((e) => {
      if (o.value && !k.value && Pe()) {
        let l = 0;
        const s = setInterval(() => {
          g.value || (m("next"), l = 0);
        }, t.interval), v = 50, B = setInterval(() => {
          l += v, g.value || (V.value = l / t.interval);
        }, v);
        e(() => {
          clearInterval(s), clearInterval(B);
        });
      }
    });
    function c(e) {
      g.value = e;
    }
    function G() {
      c(!0), h("next-button-click"), m("next");
    }
    function J() {
      c(!0), h("prev-button-click"), m("previous");
    }
    function K(e) {
      c(!0), h("navigation-click"), m(e);
    }
    function fe(e) {
      if (e === "forward") {
        G();
        return;
      }
      J();
    }
    function S() {
      k.value = !k.value, o.value = !k.value;
    }
    return R(
      () => t.autoplay,
      async (e) => {
        o.value = e, e || (k.value = !1);
      },
      { immediate: !0 }
    ), R(
      () => p.value,
      () => {
        I.value = Y(), Ce(p, () => {
          I.value = Y();
        });
      }
    ), R(
      () => a.value,
      (e) => {
        g.value && (o.value = !1), X(e);
      }
    ), pe(() => {
      y.value?.addEventListener("touchmove", q, !1), y.value?.addEventListener("touchstart", F, !1), X();
    }), ye(() => {
      y.value?.removeEventListener("touchstart", F, !1), y.value?.removeEventListener("touchmove", q, !1), ve();
    }), (e, l) => i.value ? (d(), M("div", ge({
      key: 0,
      ref_key: "carousel",
      ref: y,
      class: ["relative -mb-4 flex min-h-72 flex-col flex-wrap overflow-hidden", [e.$attrs.class, t.thumbnails?.length ?? "pb-4"]]
    }, ke({
      focusin: () => c(!0),
      focusout: () => c(!1),
      mouseout: () => c(!1),
      mouseover: () => c(!0)
    }, !0)), [
      f("div", ze, [
        x(We, {
          "current-index": a.value,
          "current-index-id": t.currentIndexId,
          items: U.value
        }, null, 8, ["current-index", "current-index-id", "items"]),
        t.autoplay && i.value > 1 ? (d(), W(r(C), {
          key: 0,
          "aria-label": P.value,
          class: "absolute bottom-12 right-12 z-10 opacity-0 transition-opacity focus:opacity-100 md:hidden",
          icon: o.value ? r($) : r(A),
          size: "small",
          variant: "primary",
          onClick: S
        }, null, 8, ["aria-label", "icon"])) : b("", !0),
        f("div", $e, [
          Ie(Q(a.value + 1) + " / " + Q(i.value) + ". ", 1),
          f("span", { "aria-labelledby": t.currentIndexId }, null, 8, Ae)
        ])
      ]),
      !j.value && i.value > 1 ? (d(), M("div", De, [
        x(ee, {
          "autoplay-running": o.value,
          "button-aria-label-translation": O.value,
          class: "mx-auto md:mx-0",
          "current-index": a.value,
          "image-count": i.value,
          "interval-progression": V.value,
          onSelect: K
        }, null, 8, ["autoplay-running", "button-aria-label-translation", "current-index", "image-count", "interval-progression"]),
        f("div", Ve, [
          t.autoplay && i.value > 1 ? (d(), W(r(C), {
            key: 0,
            "aria-label": P.value,
            icon: o.value ? r($) : r(A),
            variant: "secondary",
            onClick: S
          }, null, 8, ["aria-label", "icon"])) : b("", !0),
          x(Re, {
            "can-scroll-next": !0,
            "can-scroll-prev": !0,
            "next-alternative-text": t.alternativeNext,
            "prev-alternative-text": t.alternativePrevious,
            onScroll: fe
          }, null, 8, ["next-alternative-text", "prev-alternative-text"])
        ])
      ])) : b("", !0),
      j.value && i.value > 1 ? (d(), M("div", {
        key: 1,
        ref_key: "controllerContainerRef",
        ref: p,
        class: z(["relative isolate mx-auto flex w-full justify-center pt-12", { "h-60": t.thumbnails }])
      }, [
        f("div", {
          ref_key: "prevButtonRef",
          ref: T,
          class: z(["flex items-center px-8 py-4", se.value])
        }, [
          x(r(C), {
            "alternative-text": t.alternativePrevious,
            icon: r(Te),
            size: "small",
            type: "button",
            variant: "primary",
            onClick: J
          }, null, 8, ["alternative-text", "icon"])
        ], 2),
        f("div", {
          ref_key: "controllerWrapperRef",
          ref: L
        }, [
          x(ee, {
            "button-aria-label-translation": O.value,
            "current-index": a.value,
            "image-count": i.value,
            "prev-button-ref": T.value,
            "should-thumbnails-scroll": I.value,
            thumbnails: t.thumbnails,
            onSelect: K
          }, null, 8, ["button-aria-label-translation", "current-index", "image-count", "prev-button-ref", "should-thumbnails-scroll", "thumbnails"])
        ], 512),
        f("div", {
          class: z(["flex items-center gap-12 px-8 py-4", ce.value])
        }, [
          t.autoplay && i.value > 1 ? (d(), W(r(C), {
            key: 0,
            "aria-label": P.value,
            class: "hidden md:block",
            icon: o.value ? r($) : r(A),
            size: "small",
            variant: "secondary",
            onClick: S
          }, null, 8, ["aria-label", "icon"])) : b("", !0),
          x(r(C), {
            "alternative-text": t.alternativeNext,
            icon: r(we),
            size: "small",
            type: "button",
            variant: "primary",
            onClick: G
          }, null, 8, ["alternative-text", "icon"])
        ], 2)
      ], 2)) : b("", !0)
    ], 16)) : b("", !0);
  }
});
export {
  nt as default
};
